import React from "react";
import ReactModal from "react-modal";
import Ijmb from "./Ijmb";
import Diploma from "./Diploma";
import NCE from "./NCE";

const BtnAlevel = ({ modules }) => {
  const [showmodal, setshowmodal] = React.useState(false);

  const [data, setdata] = React.useState("");
  const [qualification, setqualification] = React.useState("");

  const _close = () => {
    setdata(null);
    setqualification(null);
    setshowmodal(false);
  };
  const _show = () => {
    setshowmodal(true);
  };

  return (
    <div>
      <ReactModal isOpen={showmodal} onRequestClose={_close} className="ReactModal">
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-center">Student A-Level Results</h5>
              <span className="pointer text-danger" onClick={_close}>
                x
              </span>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="qualification">Select A Level Qualification</label>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setdata({ type: e.target.value });
                        setqualification(e.target.value);
                      }}
                    >
                      <option>---</option>
                      <option value="IJMB">IJMB</option>
                      <option value="NCE">NCE</option>
                      <option value="Diploma">Diploma/Advance Diploma</option>
                    </select>
                  </div>
                </div>
              </div>
              {qualification === "IJMB" && <Ijmb setdata={setdata} data={data} />}
              {qualification === "Diploma" && <Diploma setdata={setdata} data={data} />}
              {qualification === "NCE" && <NCE setdata={setdata} data={data} />}
            </div>
          </div>
        </div>
      </ReactModal>
      <div>
        {!modules && (
          <div
            style={{
              position: "fixed",
              right: "50px",
              bottom: "50px",
            }}
          >
            <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
              <i className="ti-plus"></i>
            </button>
          </div>
        )}
      </div>
      <div>
        {modules && (
          <button className="btn btn-icon btn-primary btn-rounded" onClick={_show}>
            <i className="ti-pencil"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default BtnAlevel;
